<script setup lang="ts">
import { ArrowLeft, ArrowRight } from 'lucide-vue-next'
import { Card, CardContent } from '@/components/ui/card'

const { testimonials } = useLandingData()
const containerRef = ref(null)
const swiper = useSwiper(containerRef)
</script>

<template>
  <section class="mt-[45px] mb-[45px] md:mt-[80px] md:mb-[71px] container mx-auto px-4">
    <AnimateOnScroll animation="fade-up">
      <ClientOnly>
        <swiper-container
          ref="containerRef"
          :slides-per-view="1"
          :space-between="10"
          :loop="false"
          :breakpoints="{
            768: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
          }"
          class="relative px-3 sm:px-20"
        >
          <swiper-slide v-for="(item, index) in testimonials" :key="index">
            <div class="p-2">
              <Card class="rounded-md relative p-0">
                <CardContent class="flex flex-col justify-between px-4 py-3 min-h-[205px]">
                  <p class="text-center text-neutral-700">
                    {{ item.content }}
                  </p>
                  <div class="text-center mt-4">
                    <p class="text-sm font-medium text-neutral-800">
                      {{ item.name }}
                    </p>
                    <p class="mt-1 text-xs font-normal text-neutral-600">
                      {{ item.position }}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </swiper-slide>
        </swiper-container>
        <div class="absolute left-1 sm:left-3 top-1/2 -translate-y-1/2 z-20 w-[30px] sm:w-[60px] flex items-center justify-center">
          <Button variant="secondary" size="icon-lg" class="rounded-full size-12" aria-label="Slide sebelumnya" @click="swiper.prev()">
            <ArrowLeft class="size-6" aria-hidden="true" />
          </Button>
        </div>

        <div class="absolute right-1 sm:right-3 top-1/2 -translate-y-1/2 z-20 w-[30px] sm:w-[60px] flex items-center justify-center">
          <Button variant="secondary" size="icon-lg" class="rounded-full size-12" aria-label="Slide selanjutnya" @click="swiper.next()">
            <ArrowRight class="size-6" aria-hidden="true" />
          </Button>
        </div>
      </ClientOnly>
    </AnimateOnScroll>
  </section>
</template>
